import gql from 'graphql-tag'
import {
    RULE_FIELDS,
    PROJECT_FIELDS,
    READER_FIELDS,
    GROUP_FIELDS,
    GROUP_READER_RULE_FIELDS,
    GROUP_CARD_FIELDS,
    GROUP_COMPANY_FIELDS,
} from './fragments'

export const PROJECT_ACCESS_QUERY = gql`
    query projectAccess($projectId: ID!, $withPsi: Boolean!) {
        allReadersForProject(projectId: $projectId) {
            ...ReaderFields
        }
        allRulesForProject(projectId: $projectId) {
            ...RuleFields
        }
        allGroupsForProject(projectId: $projectId) {
            ...GroupFields
        }
        allGroupReaderRuleAssociationsForProject(projectId: $projectId) {
            ...GroupReaderRuleFields
        }
        allAccessGroupCompanyAssociationsForProject(projectId: $projectId) {
            ...GroupCompanyFields
        }
        allAccessGroupCardAssociationsForProject(projectId: $projectId) {
            ...GroupCardFields
        }
    }
    ${RULE_FIELDS}
    ${READER_FIELDS}
    ${GROUP_FIELDS}
    ${GROUP_READER_RULE_FIELDS}
    ${GROUP_CARD_FIELDS}
    ${GROUP_COMPANY_FIELDS}
`

export const PROJECT_ACCESS_RULES_QUERY = gql`
    query getProjectAccessRules($projectId: ID!) {
        allRulesForProject(projectId: $projectId) {
            ...RuleFields
        }
        project(projectId: $projectId) {
            ...ProjectFields
        }
    }
    ${RULE_FIELDS}
    ${PROJECT_FIELDS}
`

export const PROJECT_ACCESS_READERS_QUERY = gql`
    query getProjectAccessReaders($projectId: ID!) {
        allReadersForProject(projectId: $projectId) {
            ...ReaderFields
        }
        project(projectId: $projectId) {
            ...ProjectFields
        }
    }
    ${PROJECT_FIELDS}
    ${READER_FIELDS}
`

export const PROJECT_ACCESS_GROUPS_READERS_RULES_QUERY = gql`
    query getGroupReaderRuleAssociations($projectId: ID!) {
        allGroupReaderRuleAssociationsForProject(projectId: $projectId) {
            ...GroupReaderRuleFields
        }
    }
    ${GROUP_READER_RULE_FIELDS}
`

export const PROJECT_ACCESS_GROUPS_QUERY = gql`
    query getProjectAccessGroups($projectId: ID!, $withPsi: Boolean!) {
        allGroupsForProject(projectId: $projectId) {
            ...GroupFields
        }
        allGroupReaderRuleAssociationsForProject(projectId: $projectId) {
            ...GroupReaderRuleFields
        }
        allRulesForProject(projectId: $projectId) {
            ...RuleFields
        }
        allReadersForProject(projectId: $projectId) {
            ...ReaderFields
        }
        allAccessGroupCardAssociationsForProject(projectId: $projectId) {
            ...GroupCardFields
        }
    }
    ${RULE_FIELDS}
    ${READER_FIELDS}
    ${GROUP_FIELDS}
    ${GROUP_READER_RULE_FIELDS}
    ${GROUP_CARD_FIELDS}
`

export const PROJECT_QUERY = gql`
    query getProject($projectId: ID!) {
        project(projectId: $projectId) {
            ...ProjectFields
        }
    }
    ${PROJECT_FIELDS}
`

export const PROJECT_CARD_HISTORY_EVENTS_QUERY = gql`
    query allAccessGroupCardHistoryEventsForProjectCard($projectCardId: ID!) {
        allAccessGroupCardHistoryEventsForProjectCard(projectCardId: $projectCardId) {
            action
            bklrUser {
                id
                name
            }
            groupId
            time
        }
    }
`

export const PROJECT_GROUP_COMPANY_HISTORY_EVENTS_QUERY = gql`
    query allAccessGroupCompanyHistoryEventsForProjectCompany(
        $projectId: ID!
        $bklrInternalCompanyId: ID!
    ) {
        allAccessGroupCompanyHistoryEventsForProjectCompany(
            projectId: $projectId
            bklrInternalCompanyId: $bklrInternalCompanyId
        ) {
            action
            bklrUser {
                id
                name
            }
            groupId
            time
        }
    }
`

export const CARD_ID_VALIDATION_QUERY = gql`
    query validateCardId($value: String!) {
        validate {
            cardId(value: $value)
        }
    }
`

export const MOBILE_NUMBER_VALIDATION_QUERY = gql`
    query validateMobileNumber($value: String!) {
        validate {
            mobileNumber(value: $value)
        }
    }
`
